import { FC, ReactNode } from "react";
import { OverlayTrigger, Popover, Table } from "react-bootstrap";
import { CheckCircleFill, InfoCircle, XCircleFill } from "react-bootstrap-icons";

import { TrackingEvent } from "src/model/trackingEvent.ts";
import { formatDate, formatDateTime } from "src/utils/timeFormat.ts";

interface TrackingEventListProps {
  trackingEvents: TrackingEvent[];
}

export const TrackingEventList: FC<TrackingEventListProps> = ({ trackingEvents }) => {
  if (trackingEvents.length === 0) {
    return <div>No Tracking Events found.</div>;
  }

  const buildTrackingEventRow = (trackingEvent: TrackingEvent): ReactNode => {
    const content = JSON.parse(trackingEvent.content);
    return (
      <tr key={trackingEvent.id}>
        <td>
          {formatDateTime(trackingEvent.createdAt)}
          <br />
          {formatDateTime(trackingEvent.sentAt, "-")}
        </td>
        <td>{trackingEvent.sent ? <CheckCircleFill color="green" /> : <XCircleFill color="red" />}</td>
        <td>
          {!trackingEvent.failed ? (
            <CheckCircleFill color="green" />
          ) : (
            <>
              <XCircleFill color="red" />
              <OverlayTrigger
                placement="auto"
                overlay={
                  <Popover>
                    <Popover.Body>
                      <pre>
                        {trackingEvent.message != null
                          ? JSON.stringify(JSON.parse(trackingEvent.message), null, 2)
                          : "-"}
                      </pre>
                    </Popover.Body>
                  </Popover>
                }
              >
                <InfoCircle className="ms-2" />
              </OverlayTrigger>
            </>
          )}
        </td>
        <td>{content.event?.name}</td>
        <td>{content.event?.type}</td>
        <td>{formatDate(content.event_time)}</td>
        <td>{content.location?.un_locode ?? "-"}</td>
        <td>{content.location_type ?? "-"}</td>
        <td>{content.reference_number}</td>
      </tr>
    );
  };

  return (
    <Table className="align-middle">
      <thead>
        <tr>
          <th>Created At / Sent At</th>
          <th>Sent</th>
          <th>Success</th>
          <th>Event Name</th>
          <th>Event Type</th>
          <th>Event Date</th>
          <th>Location</th>
          <th>Location Type</th>
          <th>Reference Number</th>
        </tr>
      </thead>
      <tbody>{trackingEvents.map(buildTrackingEventRow)}</tbody>
    </Table>
  );
};
